import React from 'react'

import Players from './components/Players'
import Navbar from './components/Navbar'


function App() {
    return (
        <React.Fragment>
            <Navbar></Navbar>
            <Players></Players>
        </React.Fragment>
    )
}

export default App